import { render, staticRenderFns } from "./DocumentFilesIndex.vue?vue&type=template&id=a6c51a56&lang=pug"
import script from "./DocumentFilesIndex.vue?vue&type=script&lang=js"
export * from "./DocumentFilesIndex.vue?vue&type=script&lang=js"
import style0 from "./DocumentFilesIndex.vue?vue&type=style&index=0&id=a6c51a56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports